import { gql, TypedDocumentNode } from "@apollo/client";
import { UniversityAlumniQuery } from "./types";

export const ALUMNI_QUERY: TypedDocumentNode<UniversityAlumniQuery> = gql`
  query getUniversityStudentsComprehensive(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeUniversityStudentsInput
  ) {
    universityStudents(first: $first, last: $last, before: $before, after: $after, input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        firstName
        lastName
        middleName
        pgaId
        email
        informalName
        gender
        profilePhoto
        displayName
        contactAddressId
        latestProgram {
          id
          status
          programType {
            id
            name
          }
        }
        contactAddress {
          id
          address1
          address2
          city
          state
          postalCode
        }
        phoneNumbers {
          id
          phoneNumber
          phoneType
          phoneFormatted
        }
        addresses {
          id
          address1
          address2
          city
          state
          postalCode
        }
        primarySectionAffiliation {
          id
          primary
        }
        primarySection {
          id
          name
        }
        sectionAffiliations {
          id
          primary
          section {
            id
            name
          }
        }
        bands {
          id
          startedOn
          programType {
            id
            name
          }
        }
        mainProgramType {
          id
          name
        }
        educationLatestPgmProgram {
          curriculumVersion
          startDate
          endDate
          level
          levelCode
          careerPath
          programType
          completed
          pgmProgramCompleted
          pgmProgramExpirationDate
          levelExpirationDate
        }
        educationPgmProgramHistory {
          curriculumVersion
          startDate
          endDate
          level
          levelCode
          careerPath
          programType
          completed
          pgmProgramExpirationDate
          levelExpirationDate
        }
        university {
          name
        }
        membershipSince
        availableJobClassifications
      }
    }
  }
`;
